import dynamic from 'next/dynamic'

export const CAR = 'car'
export const BIKE = 'bike'
export const HEALTH = 'health'
export const transitionDuration = 500

const carIconInActive = 'https://acko-seo-prod.ackoassets.com/_next_static/images/purple-car-multi.svg'
const carIconActive = 'https://acko-seo-prod.ackoassets.com/_next_static/images/car-active-white.svg'
const bikeIconInActive = 'https://acko-seo-prod.ackoassets.com/_next_static/images/bike-inactive.svg'
const bikeIconActive = 'https://acko-seo-prod.ackoassets.com/_next_static/images/bike-active.svg'

export const genericTabObj = {
  car: {
    activeIcon: carIconActive,
    inActiveIcon: carIconInActive,
    iconLabel: 'Car',
    iconAlt: 'car icon'
  },
  bike: {
    activeIcon: bikeIconActive,
    inActiveIcon: bikeIconInActive,
    iconLabel: 'Bike',
    iconAlt: 'bike icon'
  }
}

export const getDynamicComponents = {
  car: dynamic(() =>
    import('@components/MainWidget/Car/carWidget')
  ),

  bike: dynamic(() =>
    import('@components/MainWidget/Bike/bikeWidget')
  )
}

export const NEW_FLOW_BANNER_HEADING = 'Looking to insure your new bike?'
export const NEW_FLOW_BANNER_SUBHEADING = 'Zero commissions, big savings'
export const NEW_FLOW_CTA_TEXTS = 'View prices'
export const NEW_FLOW_ICON_SRC = 'https://acko-cms.ackoassets.com/bike_new_flow_icon_89bbbe7570.png'
export const NEW_FLOW_ICON_ALT = 'New Bike Icon'
export const NEW_FLOW_ICON_POSITION = 'left'
export const BIKE_WIDGET_INPUT_PLACEHOLDER = 'Enter your bike number'

export const TAP_BTN_CAR_ICON = 'tap_btn_car_icon'
export const TAP_BTN_BIKE_ICON = 'tap_btn_bike_icon'
export const MOTOR_FLOATING_WIDGET_TYPE = 'motor floating widget'
export const MOTOR_PURPLE_WIDGET_TYPE = 'motor purple widget'
